import styled from 'styled-components';
import React from 'react';
import ParagraphText from 'components/Elements/ParagraphText/ParagraphText';
import { UserSession } from 'types';
import { UserTypeTag } from 'components/Tags/TxterTypeTag';
import ProfileImage from 'components/Images/ProfileImage';


const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  color: #1f1f1f;

  margin-right: 10px;
  margin-left: auto;
`;

const Thumbnail = styled.div`
  width: 45px;
  height: 45px;
  overflow: hidden;
  border-radius: 50%;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }
`;

const InfoContainer = styled.div`
  margin-right: 10px;
  margin-left: 10px;
`;

export default function UserProfile({ user }: { user: UserSession }) {
  return (
    <Container>
      <Thumbnail>
        <ProfileImage user={user} />
      </Thumbnail>

      <InfoContainer>
        <ParagraphText
          margin={0}
          fontSize={15}
          color="#fff"
        >{`${user.firstName} ${user.lastName}`}</ParagraphText>
        <UserTypeTag type={user.type} size="sm" />
      </InfoContainer>
    </Container>
  );
}
